export default "__VITE_ASSET__8P2NB14N__"